import {Component, OnInit} from '@angular/core';
import {SvgIconUtils} from '../../../common-library/svg-icon/svg-icon-utils';

@Component({
  selector: 'ld-loan-summary-tooltip',
  templateUrl: 'loan-summary-tooltip.template.html',
  styleUrls: [ './loan-summary-tooltip.style.scss' ]
})
export class LoanSummaryTooltipComponent implements OnInit {
  public icons: {} = {
    'upload-smartphone': '',
    'live-news': '',
    'fax-machine': '',
    'envelope': ''
  };

  ngOnInit() {
    for (const key in this.icons) {
      if (this.icons.hasOwnProperty(key)) {
        this.icons[key] = SvgIconUtils.appendDefaultToIconPath(key);
      }
    }
  }
}
